module.exports = __webpack_public_path__ + "static/img/3.84dc45c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/eng/3.png
// module id = EjL1
// module chunks = 0